import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,

      // Login action - stores user and tokens
      login: (user, token, refreshToken = null) => {
        set({
          user,
          token,
          refreshToken,
          isAuthenticated: true,
        })
      },

      // Logout action - clears all auth state
      logout: () => {
        set({
          user: null,
          token: null,
          refreshToken: null,
          isAuthenticated: false,
        })
      },

      // Update user data (e.g., after profile update)
      setUser: (user) => {
        set({ user })
      },

      // Update tokens (e.g., after refresh)
      setToken: (token, refreshToken = null) => {
        set((state) => ({
          token,
          refreshToken: refreshToken ?? state.refreshToken,
        }))
      },

      // Check if user has specific role
      hasRole: (role) => {
        const { user } = get()
        if (!user) return false
        return user.role === role || user.roles?.includes(role)
      },

      // Check if authenticated
      checkAuth: () => {
        const { token, user } = get()
        return !!(token && user)
      },
    }),
    {
      name: 'Rayoptics-auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)

export { useAuthStore }
export default useAuthStore
